import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import CreateCheckForm from "../../../components/InstrallationWorkForm/CheckReceive/CreateCheckForm";
import { useState } from "react";
import InFormInstallAcceptService from "../../../services/informinstallaccept.service";
import { addEditServiceRequest } from "../../../commons/ServiceRequest";

export default function EditCheck() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [editData, setEditData] = useState({ type: "edit" });
  const commonNavigate = (Accept_Id) => {
    navigate("/installation_work/check", {
      state: { name: "data", searchValue: `${Accept_Id}` }
    });
    navigate(0);
  };

  const handleSubmit = (dataCallback) => {
    dataCallback.forEach((item) => {
      const Accept_Id = item?.id;
      const itemCopy = { ...item }; // สร้างคัดลอกของ item ก่อนลบ "id" ออก
      delete itemCopy.id;
      const serviceRequest = InFormInstallAcceptService.editInFormInstallAccept(
        Accept_Id,
        itemCopy // ใช้คัดลอกของ item ที่ไม่มี "id" ในการแก้ไขข้อมูล
      );
  
      addEditServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: serviceRequest,
        navigated: (navi) => navi && commonNavigate(Accept_Id)
      });
    });
  };
  

  return (
    <CreateCheckForm editData={editData} onSubmitCallback={handleSubmit} />
  );
}
